import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrimaryColourService extends HttpService<any, any> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'primary-colour');
  }

  /** Admin list with linked-attribute count. Optional name search. */
  listPrimaryColours(search = ''): Observable<any> {
    const action = search ? `admin?search=${encodeURIComponent(search)}` : 'admin';
    return this.getBy(action);
  }

  /** Public list — used to populate the Primary Colour dropdown on the attribute modal. */
  listForDropdown(): Observable<any> {
    return this.getBy('');
  }

  getPrimaryColourById(id: number | string): Observable<any> {
    return this.getBy(`admin/${id}`);
  }

  createPrimaryColour(payload: any): Observable<any> {
    return this.create(payload, 'admin');
  }

  updatePrimaryColour(id: number | string, payload: any): Observable<any> {
    return this.update(payload, `admin/${id}`);
  }

  deletePrimaryColour(id: number | string): Observable<any> {
    return this.delete(id, 'admin');
  }
}
